export default __webpack_public_path__ + "static/media/critical.f1d8205a.svg";